import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecisionAnswer {
    /**
     * @constructor
     */
    constructor(id, answer, feedback, rating) {
        this._id = id;
        this._answer = answer;
        this._feedback = feedback;
        this._rating = rating;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get answer() {
        return this._answer;
    }

    set answer(value) {
        this._answer = value;
    }

    get feedback() {
        return this._feedback;
    }

    set feedback(value) {
        this._feedback = value;
    }

    get rating() {
        return this._rating;
    }

    set rating(value) {
        this._rating = value;
    }
}
KeyDecisionAnswer.GOOD_RATING = "good"
KeyDecisionAnswer.MEDIUM_RATING = "medium"
KeyDecisionAnswer.BAD_RATING = "bad"